import React from 'react';
import './TableOfContents.css';

const TableOfContentsItem = props => {
  const { contentItem } = props;
  const formattedContentItem = contentItem.split(' ')
                                          .map( word => word.toLowerCase() )
                                          .join('-');
  return (
    <p className="table-of-contents-list-item">
      <a href={`#${ formattedContentItem }`}>{ contentItem }</a>
    </p>
  )
}

const TableOfContents = props => {
  const { contents } = props;
  return (
    <div className="table-of-contents">
      <h2>Contents</h2>
      { contents.map( (contentItem, index) => (
        <TableOfContentsItem contentItem={ contentItem } key={ index }></TableOfContentsItem>
      )) }
    </div>
  )
}

export default TableOfContents;


// WEBPACK FOOTER //
// ./src/components/TableOfContents.js